export default __webpack_public_path__ + "static/media/Nameless Glaive.40f950fa.jpg";